import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  ImageList,
  ImageListItem,
  GridListTileBar,
  IconButton,
} from "@material-ui/core";
import CheckCircleOutlineRoundedIcon from "@material-ui/icons/CheckCircleOutlineRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";

// Contexts
import FacebookAdContext from "../../../../context/facebook_profiles/ad/AdContext";

// Components
import Spinner from "../../../layout/SpinnerSmall";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 500,
  },
  grid: {
    height: "auto",
  },
  image: {
    "&:focus": {
      outline: "none",
    },
    objectFit: "contain",
  },
  load: {
    marginTop: "1rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const ImageSelection = ({
  browserOpen,
  browserClose,
  browserSave,
  image_url,
}) => {
  const classes = useStyles();

  const { browseImage, images, image_next_cursor, browse_loading } =
    useContext(FacebookAdContext);

  const [selectedImage, setSelectedImage] = useState("");
  const [selectedFilename, setSelectedFilename] = useState("");

  const onSelect = (url, public_id) => {
    setSelectedImage(url);
    setSelectedFilename(public_id);
  };

  const onLoadMore = () => {
    browseImage("more");
  };

  const onSave = () => {
    setSelectedImage("");
    setSelectedFilename("");
    browserSave(selectedImage, selectedFilename);
  };

  const onCancel = () => {
    setSelectedImage("");
    setSelectedFilename("");
    browserClose();
  };

  useEffect(() => {
    if (browserOpen) {
      browseImage();

      if (images && image_url) {
        images.map((image) => {
          if (image.secure_url === image_url) {
            setSelectedImage(image_url);
            setSelectedFilename(image.public_id);
          }
        });
      }
    }
  }, [browserOpen]);

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="md"
      open={browserOpen}
      onClose={browserClose}
    >
      <DialogTitle> Select image </DialogTitle>
      <DialogContent dividers className={classes.root}>
        <ImageList cols={4} className={classes.grid}>
          {images && images.length === 0 && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{
                width: "100%",
                height: 435,
              }}
            >
              <Typography variant="body1"> No image found. </Typography>
            </Grid>
          )}
          {images &&
            images.map((image) => {
              return (
                <ImageListItem key={image.public_id}>
                  <div
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      height="180"
                      width="225"
                      src={image.secure_url}
                      className={classes.image}
                      alt=""
                    />
                  </div>
                  <GridListTileBar
                    title={image.filename}
                    actionIcon={
                      <IconButton
                        className={classes.button}
                        onClick={() =>
                          onSelect(image.secure_url, image.public_id)
                        }
                      >
                        {selectedImage === image.secure_url ? (
                          <CheckCircleRoundedIcon color="secondary" />
                        ) : (
                          <CheckCircleOutlineRoundedIcon color="secondary" />
                        )}
                      </IconButton>
                    }
                  />
                </ImageListItem>
              );
            })}
        </ImageList>
        {image_next_cursor && (
          <Grid container justifyContent="center" className={classes.load}>
            {browse_loading ? (
              <Spinner />
            ) : (
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={onLoadMore}
              >
                Load more
              </Button>
            )}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onSave}
          disabled={selectedImage ? false : true}
        >
          Select
        </Button>
        <Button
          variant="contained"
          className={classes.button}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageSelection;
